import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import classNames from 'classnames';

import {
  getIdentityAccounts,
  getIdentityFullName,
} from '../../../../../../../../../util/identity';
import { getThumbBySize } from '../../../../../../../../../util/photo';
import { IMAGE_SIZE_CODE } from '../../../../../../../../../constants/image-size-codes';
import {
  getAccountLastDigits,
  getAccountName,
} from '../../../../../../../../../util/account';
import IdentityAvatar from '../../../../../../../../../components/global/identity/IdentityAvatar';

const propTypes = {
  identity: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
  }),
  isOverlay: PropTypes.bool,
};

const IdentitySelectorOption = ({ identity, isOverlay, className }) => {
  const accounts = getIdentityAccounts(identity);
  const identityThumb = getThumbBySize(
    identity?.current_matching_photo?.thumbnail_urls ?? [],
    IMAGE_SIZE_CODE.MEDIUM,
  );

  const classes = classNames({
    'manual-matching-identity-selector-option': true,
    [className]: !!className,
  });

  return (
    <div className={classes} key={identity.id}>
      <div className="d-flex">
        <div
          data-tip=""
          data-for={`tooltip-identity-selfie-${identity.id}`}
          data-place="bottom"
        >
          <IdentityAvatar
            key={identity.id}
            identity={identity}
            title={identity.name}
            className="mr-1"
            selfieType="any"
          />
          {identityThumb && !isOverlay && (
            <ReactTooltip
              delayHide={250}
              className="face-tag-photo-tooltip"
              id={`tooltip-identity-selfie-${identity?.id}`}
              backgroundColor="transparent"
              arrowColor="transparent"
              effect="solid"
            >
              <img src={identityThumb.url} alt="Identity Selfie" />
            </ReactTooltip>
          )}
        </div>

        <div>
          <span className="d-block">
            {getIdentityFullName(identity, identity.account)}
          </span>
          {accounts.map(account => {
            if (!account) {
              return null;
            }

            const number = getAccountLastDigits(account);

            return (
              <span className="d-block text-faded text-xs" key={account.id}>
                {getAccountName(account)} {number && `(${number})`}
              </span>
            );
          })}
        </div>
      </div>
    </div>
  );
};

IdentitySelectorOption.propTypes = propTypes;

export default IdentitySelectorOption;
